// TODO this should be done by SalvTable out of the box
import { InternalApiSortDirection } from '../api-internal';
import { SortingState, Updater } from '@tanstack/react-table';

export const getOrderByAndDirection = (updaterOrValue: Updater<SortingState>, sortingState: SortingState) => {
  const newState = typeof updaterOrValue === 'function' ? updaterOrValue(sortingState) : updaterOrValue;

  const firstColumnSort = newState.length ? newState[0] : undefined;

  if (!firstColumnSort) {
    return { orderBy: undefined, direction: undefined };
  }
  const orderBy = firstColumnSort.id;
  const direction = firstColumnSort.desc ? InternalApiSortDirection.DESC : InternalApiSortDirection.ASC;

  return { orderBy, direction };
};
